export class FindAllDefaultRolesError {
  public static readonly type =
    '[Group/GroupRoles/List] FindAllDefaultRolesError';
  constructor(public readonly error: Error) {}
}
